<template>
  <v-dialog
    v-model="dialogfiltre"
    @keydown.esc="cancel"
    v-if="aktifmi"
    scrollable
    persistent
    max-width="400px"
  >
    <v-card flat color="grey lighten-4">
      <v-card-title>{{ $t("Filter-selection") }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm6 md12 pa-1>
            <v-card flat class="white--text">
              <v-card flat color="grey lighten-5">
                <v-card-actions>
                  <v-layout row wrap>
                    <v-flex md12 xs12 sm12>
                      <pnrbul
                        v-model="filterData.Filtreler.Prm.PPNR_No"
                        hide-details
                      >
                      </pnrbul>
                    </v-flex>

                    <v-flex md12 xs12 sm12>
                      <cariaracomp
                        v-bind:etiket="$t('Currentcode_label')"
                        v-bind:value="filterData.Filtreler.Prm.PCariKod"
                        v-model="filterData.Filtreler.Prm.PCariKod"
                        :Coper="true"
                      ></cariaracomp>
                    </v-flex>

                    <v-flex md12 xs12 sm12>
                      <takipno
                        v-model="filterData.Filtreler.TakipNo"
                        hide-details
                      >
                      </takipno>
                    </v-flex>

                    <v-flex md12 xs12 sm12>
                      <cariaracomp
                        v-bind:etiket="$t('Current-Main-Account')"
                        v-bind:value="filterData.Filtreler.Prm.PCariAnaHesap"
                        v-model="filterData.Filtreler.Prm.PCariAnaHesap"
                        :Coper="true"
                      ></cariaracomp>
                    </v-flex>

                    <v-flex md6 xs12 sm6>
                      <v-select
                        clearable
                        :items="itemssaticitip"
                        item-text="Aciklama"
                        item-value="Kod"
                        v-model="filterData.Filtreler.Prm.PSaticiTip"
                        :label="$t('Seller-Type')"
                        hide-details=""
                      >
                      </v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <genelarama
                        :autofocuss="true"
                        apiname="SaticiAra"
                        :tip="filterData.Filtreler.Prm.PSaticiTip"
                        :label="$t('Seller-Code')"
                        v-model="filterData.Filtreler.Prm.PSaticiKod"
                      ></genelarama>
                    </v-flex>

                    <v-flex pl-1 xs12 sm12 md12>
                      <genelarama
                        apiname="MasrafMerkeziAra"
                        :label="$t('Expense-Center-v2')"
                        v-model="filterData.Filtreler.Prm.PMasrafMerkezi"
                      ></genelarama>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <referansmerkezicomp
                        v-model="filterData.Filtreler.Prm.PReferans"
                        :etiket="$t('Reference-Centre')"
                        :coper="true"
                      >
                      </referansmerkezicomp>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <genelarama
                        apiname="SaticiAra"
                        :tip="12"
                        label="Tur Operatörü"
                        v-model="filterData.Filtreler.Prm.PTurOp"
                      >
                      </genelarama>
                    </v-flex>

                    <v-flex md12 xs12 sm12>
                      <v-select
                        :items="itemsicdis"
                        item-text="text"
                        item-value="value"
                        v-model="filterData.Filtreler.Prm.PSaticiIc_Dis"
                        label="İç Dış"
                        hide-details=""
                      >
                      </v-select>
                    </v-flex>

                    <v-flex md12 xs12 sm12>
                      <v-select
                        :items="itemsopsiyon"
                        item-text="text"
                        item-value="value"
                        v-model="filterData.Filtreler.Prm.POpsiyon"
                        :label="$t('Optional-Sales')"
                        hide-details=""
                      >
                      </v-select>
                    </v-flex>

                    <v-flex md12 xs12 sm12>
                      <anatip
                        v-model="filterData.Filtreler.Prm.PAnaTip"
                      ></anatip>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        hide-details
                        v-model="filterData.Filtreler.Prm.PCariHesapGrubu"
                        :label="$t('Account-Group')"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        hide-details
                        v-model="filterData.Filtreler.Prm.PSaticiGrup"
                        :label="$t('Seller-Group')"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        hide-details
                        v-model="filterData.Filtreler.Prm.PSatisFaturaNo"
                        :label="$t('Invoice-No')"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-select
                        hide-details
                        :items="itemssatisfatura"
                        v-model="filterData.Filtreler.Prm.PFaturali"
                        item-text="text"
                        item-value="value"
                        label="Satış Faturalı"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-select
                        hide-details
                        :items="itemskomisyon"
                        v-model="filterData.Filtreler.Prm.PKomisyonFaturali"
                        item-text="text"
                        item-value="value"
                        :label="$t('Commission-Invoice')"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <genelarama
                        apiname="KullaniciAra"
                        :label="$t('Booker') + ':'"
                        v-model="filterData.Filtreler.Prm.PPNRBir"
                      ></genelarama>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-checkbox
                        label="Iptal Edilen Rezervasyonları Göster"
                        v-model="filterData.Filtreler.Prm.PIptalDahil"
                      ></v-checkbox>
                    </v-flex>
                 
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="cancel()">{{
          $t("cancel_button")
        }}</v-btn>
        <v-btn color="blue darken-1" flat @click.native="agree()">{{
          $t("Apply-Filters")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import rez from "@/components/app/coper/rezervasyon.js";
import takipno from "@/components/app/coper/component/takipno.vue";

export default {
  props: {
    aktifmi: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      itemskomisyon: [
        {
          text: this.$t("None"),
          value: false,
        },
        {
          text: this.$t("Available"),
          value: true,
        },
        {
          text: this.$t("All-v2"),
          value: null,
        },
      ],

      itemssatisfatura: [
        {
          text: this.$t("None"),
          value: false,
        },
        {
          text: this.$t("Available"),
          value: true,
        },
        {
          text: this.$t("All-v2"),
          value: null,
        },
      ],

      itemssaticitip: rez.SaticiTip,
      itemsicdis: rez.IcDis,
      itemsopsiyon: rez.Opsiyon,
      dialogfiltre: false,
      filterData: {},
      cancelValue: {},
    };
  },
  methods: {
    agree() {
      this.$emit("dialogFilterAgree", this.filterData);
    },
    open(value) {
      this.cancelValue = JSON.parse(JSON.stringify(value));
      this.filterData = Object.assign({}, value);
      this.dialogfiltre = true;
    },
    cancel() {
      this.$emit("dialogFilterCancel", this.cancelValue);
      this.dialogfiltre = false;
    },
    close() {
      this.dialogfiltre = false;
    },
  },
  components: {
    cariaracomp,
    referansmerkezicomp,
    pnrbul,
    genelarama,
    anatip,
    takipno,
  },
};
</script>

<style></style>
